module.exports = __webpack_public_path__ + "dist/img/persbehav.1dbc36cd.svg";